<template>
  <f7-page id="page-account-home" name="account-home" @page:afterin="afterin">

    <f7-navbar class="view-mobile no-border">
        <f7-nav-left class="back-button">
            <f7-link icon-f7="chevron_left" @click="backButton" color="black"></f7-link>
        </f7-nav-left>
        <f7-nav-right></f7-nav-right>
    </f7-navbar>

    <f7-block>
      <div>
        <div class="mt-5 mb-0 display-flex align-items-center fs-20 b" :class=" isModifyAlias == true ? 'd-none' : '' ">
          <span class="account-alias" :class=" customerAlias.trim() == '' ? ' text-color-green fw-normal' : ''">{{customerAlias.trim() == "" ? $t('ua-alias-help') : customerAlias}}</span>
          <span class="mt-sm ml-sm">
            <f7-link @click="modifyAlias" color="black">
              <img :src="require('@/assets/img/icon/icon-pencil.svg')">
            </f7-link>
          </span>
        </div>

        <div :class=" isModifyAlias == true ? '' : 'd-none' ">
          <transition name="fade">
            <f7-card
                class   ="alert alert-danger mb-md"
                v-show  ="alertCard.show"
            >
                <div v-html="alertCard.title" slot="header"></div>
                <i class="icon f7-icons card-close" @click="alertCard.show=false">xmark</i> 
            </f7-card>
          </transition>

          <f7-list class="form-group customer-alias no-margin">
            <f7-list-input
              id            ="reg-customer-alias"
              input-id      ="customerAlias"
              name          ="customerAlias"
              type          ="text"
              label         =""
              placeholder   =""
              @change       ="customerAliasTemp = $event.target.value; validateInput($event.target);"
              :value        ="customerAliasTemp"
              autocomplete  ="off"
              clear-button
            >
              <div slot="content" class="">
                <f7-button round large fill @click="saveAlias()" class="pl-md pr-md" :disabled="isValidAlias == true ? false : true">{{$t('beneficiary-btn-save')}}</f7-button>
              </div>
            </f7-list-input>
          </f7-list>
        </div>
        <p class="m-0">{{email}}</p>
        <p class="m-0">{{mobileCountryCode}} {{mobile}}</p>
      </div>

      <div class="card mt-lg">
        <f7-list class="list-menu">
          <f7-list-item class="pl-20 pr-20" @click="$f7router.navigate('/account/invite-earn', { transition: 'f7-push' })" :title="$t('general-text-invite-earn')">
            <div slot="media"><img :src="require('@/assets/img/icon/account-user-add.svg')" class="filter-icon"></div>
          </f7-list-item>
        </f7-list>
      </div>

      <f7-list class="sh-list-nav has-border margin-16">
        <f7-list-item link="/account/my-details" :title="$t('general-text-details')">
          <img src="../../assets/img/icon/account-user.svg" slot="media" />
        </f7-list-item>

        <f7-list-item link="/account/fx-alert" :title="$t('general-text-fx-alert')">
          <img src="../../assets/img/icon/account-dollar-square.svg" slot="media" />
        </f7-list-item>
        <f7-list-item link="/notification" :title="$t('general-text-notification')" @click="navigateTo('notification')">
          <img src="../../assets/img/icon/account-notification-bing.svg" slot="media" />
          <span v-if="countUnreadInbox > 0" class="badge-notif-number">{{ countUnreadInbox }}</span>
        </f7-list-item>

        <f7-list-item link="/account/my-coupon" :title="$t('general-text-coupons')">
          <img src="../../assets/img/icon/account-archive-book.svg" slot="media" />
        </f7-list-item>

        <f7-list-item link="/setting" :title="$t('general-text-settings')" v-if="showMenuSettings" >
          <img src="../../assets/img/icon/account-setting.svg" slot="media" />
        </f7-list-item>

        <f7-list-item link="/account/help-and-support" :title="$t('general-text-support')">
          <img src="../../assets/img/icon/account-like.svg" slot="media" />
        </f7-list-item>

        <f7-list-item @click="doLogout" :title="$t('general-text-logout')" class="text-color-red">
          <img src="../../assets/img/icon/account-logout.svg" slot="media" />
        </f7-list-item>

      </f7-list>
      <div v-if="versionApp" class ="text-align-center fs-12">
        <p class="m-0">{{$t('general-text-app-version', {version:versionApp})}}</p>
      </div>
    </f7-block>
  </f7-page>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";

  export default {
    data() {
			return {
				routerTo    : "",
        //customer    : this.$store.state.customer,
        invitecode  : "qwek2a2oaw",
        versionApp  : "",
        countUnreadInbox  : 0,
        showMenuSettings: !this.$f7.device.desktop,
        customerAliasTemp : "",
        isModifyAlias : false,
        alertCard: {
            show   : false,
            title  : "",
            content: ""
        },
			}
		},
    mounted(){
      // Required for everypage. Toggle desktop-view footer.
      this.toggleFooterVisibility(false)
      this.$f7.$('.page-content').on('scroll', (e) => {
        this.toggleFooterVisibility(e.target)
      })
      this.checkNotification()

      this.customerAliasTemp = this.customerAlias
      // this.setCustomerAliasTemp(this.customerAlias)
      this.setIsValidAlias(true)
      if (window.Android || window.webkit) {
        this.checkBiometryAvaibility();
        this.$root.$once("handleBiometryType", (type) => {
          // 0 = None, 1 = Fingerprint, 2 = Face ID
          if(type== 1){
            this.showMenuSettings=true;
          } else if(window.webkit && type== 2){
            this.showMenuSettings=true;
          }else{
            this.showMenuSettings=false;
          }
        });
        this.getVersionApp();
        this.$root.$once("retrieveVersionApp", (version) => {
          this.versionApp =version
          console.log('version app '+this.versionApp)
        });
      }

      if(this.isAxsr) { // ARBP-35
        this.showMenuSettings = false;
      }
    },
		computed: {
			...mapGetters('auth', [
				'authenticating',
				'authenticationError',
				'authenticationErrorCode',
				'authenticationSuccess',
        'loggedIn',
			]),
      ...mapGetters('customer', [
          'customerAlias',
          // 'customerAliasTemp',
          'isValidAlias',
          'email',
          'mobile',
          'mobileCountryCode',
      ]),
      ...mapGetters('registration', ['isAxsr']),
		},
    methods: {
      ...mapActions('auth', ['login', 'logout']),
      ...mapActions('customer', ['setCustomerAlias', 'setCustomerAliasTemp', 'setIsValidAlias', 'setIsModifyAlias', 'validateInput']),

      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },
      copyText(text){
        var copyText = document.getElementById(text);
        var textArea = document.createElement("textarea");
        textArea.value = copyText.textContent;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("Copy");
        textArea.remove();
      },

      doLogout() {
        console.log("Account home, Logging out.....");
        console.log("AXS ? "+this.isAxsr);

        this.logout();
        if(!this.authenticationSuccess && !this.loggedIn){
          if(this.isAxsr){
            this.$f7.views.main.router.navigate("/axsr-login", { force: true, clearPreviousHistory: true, transition: 'f7-fade' })
          }else{
            this.$f7router.navigate("/login", { force: true, clearPreviousHistory: true, transition: 'f7-fade' });
          }
        }
      },

      navigateTo(page){
        switch(page) {
					case "notification"   :
            this.$store.state.customer.routerTo = "/account";
            this.$f7router.navigate("/notification");
            break;
					case "helpAndSupport" : this.$f7router.navigate('/account/help-and-support', { transition: 'f7-push' });break;
					default               : this.$f7router.navigate("/home"); break;
				}
      },

      backButton(){
				switch(this.routerTo) {
					case "accounthome" : this.$f7router.navigate("/account"); break;
					default       : this.$f7router.navigate("/home"); break;
					// default            : this.$f7router.back({ transition: 'f7-push' }); break;
				}
			},

      checkNotification(){
        const self = this
        const customerInboxMessagesPromise  = self.$api.customer.getInboxMessage(0, 0, 0);
        customerInboxMessagesPromise.then(function(mInbox) {
          self.countUnreadInbox = mInbox.length;
        });
      },

      modifyAlias(){
        this.isModifyAlias = true;
        this.setIsModifyAlias(true)
      },

      async saveAlias(){
        this.showPreloader();
        if(!this.customerAliasTemp){ this.customerAliasTemp = "" }
        // if(!this.customerAliasTemp){ this.setCustomerAliasTemp("") }
        //console.log("ALIAS LENGTH : "+this.customerAliasTemp.length+" ## "+this.customerAliasTemp.trim().length)
        //this.setCustomerAlias(this.customerAliasTemp)
        //this.validateInput({id: "customerAlias", value: this.customerAliasTemp});
        if(this.isValidAlias === true){ // ALIAS VALID
          const result = await this.$api.customer.saveAlias(this.customerAliasTemp.trim());
          //console.log("saveAlias RES : ", result)

          if(result.status == "WN00140"){ // SUCCESS
            this.showAlert(false, "");
            const custDetails = await this.$api.customer.getCustomerDetails();
            //console.log("NEW DETAILS : ", custDetails)
            this.setCustomerAlias(custDetails.customerAlias)
            this.customerAliasTemp = this.capitalizeEachWord(custDetails.customerAlias)
            // this.setCustomerAliasTemp(this.capitalizeEachWord(custDetails.customerAlias))
            this.setZohoChatbotCustomer();
            this.isModifyAlias = false;
            this.setIsModifyAlias(false)
            this.hidePreloader();
          }else if(result.status == "WN00141"){ // EXCEPTION
            console.log("SAVE ALIAS : "+result.message)
            this.showAlert(true, this.t('general-error-text'))
            this.hidePreloader();
          }else{
            console.log("SAVE ALIAS : "+result.message)
            this.showAlert(true, this.t('general-error-text'))
            this.hidePreloader();
          }
        }else{
          this.hidePreloader();
        }
      },

      showAlert(status, title, content){
        this.alertCard.show = status;
        if (title == undefined){
          title = "";
        }
        if (content == undefined){
          content = "";
        }
        this.alertCard.title= title;
        this.alertCard.content = content;

      },
    }
  }
</script>